<template>
    <div id="home-container"
    >
        <header-home></header-home>
        <thumb-view v-show="booklistState.viewMode==='thumb'"></thumb-view>
        <list-view v-show="booklistState.viewMode==='list'"></list-view>
        <footer-home></footer-home>
    </div>

</template>

<script>

    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed}  from "vue";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {useBookList} from "@/modules/home/booklist";
    import FooterHome from "@/views/footer/FooterHome";
    import HeaderHome from "@/views/header/HeaderHome";
    import ThumbView from "@/views/home/ThumbView";
    import ListView from "@/views/home/ListView";
    import config from "@/config/config.json";
    import cssvar from '@/scss/_variables.scss';

    export default {
        components: {
            FooterHome,
            HeaderHome,
            ThumbView,
            ListView
        },
        setup(props, context) {

            const {booklistState} = useBookList();
            return {
                booklistState
            }
        }
    }

</script>
<style lang="scss" scoped>

    body {
        touch-action:auto;
    }

    #home-container {
        display:table;
        background: $color-primary-light;
        width:100%;
        min-height:100%;
    }

</style>